import { postPortalGQL, postPortalGQLFile } from 'api/wenjetso/graphql'
import { useSnackbar } from 'libs/ui/snackbar'
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next'
import { useLoading } from 'libs/form/loadingHook'

export const getFirstErrorCode = (response) => {
  if (response && response.error && Array.isArray(response.error.errors)) {
    return response.error.errors[0].extensions.code
  }
  return null
}

export const useApiCall = () => {
  const { t } = useTranslation()
  const { showError } = useSnackbar()
  const { navigate } = useI18next()

  const handleError = (response) => {
    if (response.error) {
      let errMsg
      if (response.error.isSystemError) {
        errMsg = t('errorCodes.50000')
      } else if (response.error.isRequestFail) {
        errMsg = t('error.checkNetwork')
      } else if (response.error.isUnauthorized) {
        errMsg = t('error.unauthorized')
        navigate('/login/')
      }

      if (errMsg) {
        showError(errMsg)
      }
    }
    return response
  }

  const requestGraphQL = async (query, variables, token, options) => {
    const response = await postPortalGQL(query, variables, token, options)
    return handleError(response)
  }

  const requestGraphQLFiles = async (query, variables, fileObj, token, options) => {
    const response = await postPortalGQLFile(query, variables, fileObj, token, options)
    return handleError(response)
  }
  
  return {
    requestGraphQL,
    requestGraphQLFiles,
  }
}

export const useApiCallLoading = () => {
  const { requestGraphQL } = useApiCall()
  const { isLoading, processAsyc } = useLoading()
  const wrapApiCall = async (query, variables, token, options) => {
    const response = await processAsyc(requestGraphQL(query, variables, token, options))
    return response
  }

  return {
    isRequestLoading: isLoading,
    requestGraphQL: wrapApiCall
    // TODO: batchRequest
  }
}